import Rest from '../Rest'

export default class NaturalEntityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/natural_entities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
